import { api } from 'pages/APIs';
import type { dynamicObj } from 'src/pages/assets';
import helperUtil from 'src/utils/helperUtil';
import DocumentDetailApiService from 'src/services/document/DetailApiService';

export default class DocumentPOApiService extends DocumentDetailApiService {
  public constructor() {
    super({});
  }

  getExtAppPODocumentByID(id: string): Promise<any> {
    return super.get(api.get_ext_po_match_data + id + '?version=v1');
  }

  saveExtAppDocument(data: dynamicObj, id: string): Promise<any> {
    const formData = new FormData();
    formData.append('data', JSON.stringify(data));
    return super.post(api.save_ext_po_data + id, formData);
  }

  async purchaseOrdersSearch(data: any) {
    const querystring = this.encodeQueryData(data);
    logInfo('querystring', querystring);

    return await super.get(api.purchase_orders_search + '?' + querystring, {});
  }

  async getToleranceList(data: any) {
    const querystring = this.encodeQueryData(data);
    return super.get(api.get_tolerance_list + '?' + querystring, {});
  }

  setItemTolerance(toleranceModel: any): Promise<any> {
    const formData = new FormData();
    for (const key of Object.keys(toleranceModel)) {
      formData.append(key, toleranceModel[key]);
    }

    return super.post(api.set_item_tolerance, formData);
  }

  public async autoMatch(data: dynamicObj): Promise<any> {
    const formData = new FormData();
    for (const key of Object.keys(data)) {
      formData.append(key, data[key]);
    }

    return super.post(api.auto_po_match, formData);
  }

  public async autoMatch_v2(data: dynamicObj): Promise<any> {
    const formData = new FormData();
    for (const key of Object.keys(data)) {
      formData.append(key, data[key]);
    }

    return super.post(api.auto_po_match_v2, formData);
  }

  public async connectLineItemWithPOLineItem(
    data: any,
    table_line_ids: string,
    po_line_ids: string,
  ): Promise<any> {
    const formData = new FormData();
    formData.append('data', data);
    formData.append('po_line_ids', po_line_ids);
    formData.append('table_line_ids', table_line_ids);

    return super.post(api.manual_match_lines, formData);
  }

  public async getPOitems(data: dynamicObj): Promise<any> {
    data['populate_additional_charges'] = true;
    const querystring = this.encodeQueryData(data);
    return super.get(api.get_purchase_order_data + '?' + querystring, {});
  }

  public async getSupplierItemNumbers(data: dynamicObj): Promise<any> {
    const querystring = this.encodeQueryData(data);
    return super.get(api.supplie_item_numbers + '?' + querystring, {});
  }

  public async getAllSupplierItemNumbers(data: dynamicObj): Promise<any> {
    const querystring = this.encodeQueryData(data);
    return super.get(api.supplie_item_numbers_list + '?' + querystring, {});
  }

  public async deleteSupplierItemNumber(id: string): Promise<any> {
    return this.delete(api.delete_supplie_item_number + id, {});
  }

  public async getPODisplayColumns(data: dynamicObj): Promise<any> {
    const querystring = this.encodeQueryData(data);
    return super.get(
      api.get_purchase_order_display_cols + '?' + querystring,
      {},
    );
  }

  public async syncData(data: dynamicObj): Promise<any> {
    const formData = new FormData();
    for (const key of Object.keys(data)) {
      formData.append(key, data[key]);
    }

    return super.post(
      api.sync_receive_delivery_for_purchase_orders_by_api,
      formData,
    );
  }

  public async get_all_display_cols(): Promise<any> {
    return super.get(api.get_all_purchase_order_display_cols);
  }
}
